export default {
  fontFamily: 'Inter',
  displayMedium: {
    fontSize: 28,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '32px',
    letterSpacing: 0.28,
  },
  displaySmall: {
    fontSize: 24,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '32px',
    letterSpacing: 0.24,
  },
  bodyLarge: {
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: 0.02,
  },
  bodyMedium: {
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: 0.02,
  },
  labelLarge: {
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: 0.02,
  },
  labelMedium: {
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: 0.14,
  },
  labelSmall: {
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: 0.12,
  },
  titleSmall: {
    fontSize: 18,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '32px',
    letterSpacing: 0.18,
  },
  titleMedium: {
    fontSize: 22,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '32px',
    letterSpacing: 0.22,
  },
  h1: {
    //styleName: display/large
    fontSize: '32px',
    fontWeight: 600,
    lineHeight: '40px',
    letterSpacing: '0.34px',
  },
  h2: {
    //styleName: display/small
    fontSize: 24,
    fontWeight: 600,
    lineHeight: '32px',
    letterSpacing: '-0.02em',
  },
  h3: {
    //styleName: title/small
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '32px',
    letterSpacing: '-0.02em',
  },
  h4: {
    //styleName: label/large
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
  },
  body1: {
    //styleName: body/large;
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.02em',
  },
  body2: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '24px',
    letterSpacing: '0.02em',
  },
  bodySmall: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.12px',
  },
  caption: {
    color: 'rgba(0, 0, 0, 0.72)',
  },
};
